module.exports = __webpack_public_path__ + "static/media/sticker-mule.bc1464b3.svg";